export default function convertStringToSlug (text: string){
    const formatted = text
    .normalize("NFD")               // Splits chars like 'ë' into 'e' + '¨'
    .replace(/[\u0300-\u036f]/g, "") // Removes the accent marks
    .toLowerCase()
    .replace(/\s+/g, '-')           // Replaces spaces with hyphens
    .replace(/[^a-z0-9-]/g, '')     // Now safe to remove non-alphanumerics
    .replace(/--+/g, '-');          // Collapses multiple hyphens
    return formatted
}
